(() => {
  if (window.MKBackerColors) { window.MKBackerColors.swatches(); return; }
  const palette = JSON.parse(document.querySelector('[data-mk-backer-palette]')?.textContent || '{}');
  const normalized = value => String(value || '').toLowerCase().trim().replace(/gray/g,'grey');
  const lookup = Object.fromEntries(Object.entries(palette).map(([name,hex]) => [normalized(name),hex]));
  const color = name => lookup[normalized(name)] || (normalized(name)==='orange' ? lookup['pumpkin orange'] : null);
  function tintPixels(data,hex,whiteMask=false,lighting={}) {
    const rgb = hex.replace('#','').match(/.{2}/g).map(value=>parseInt(value,16)), histogram=new Uint32Array(256);
    let transparent=lighting.transparent||false, count=lighting.count||0;
    if(!lighting.histogram){
    for (let index=0;index<data.length;index+=4) {
      if(data[index+3]<200) transparent=true;
      if(data[index+3]>240) { histogram[Math.round(.2126*data[index]+.7152*data[index+1]+.0722*data[index+2])]++;count++; }
    }
    lighting.histogram=histogram;lighting.count=count;lighting.transparent=transparent;
    }else histogram.set(lighting.histogram);
    if(!transparent || !count) throw new Error('Backer preview requires a transparent white cutout.');
    const percentile=fraction=>{
      let cumulative=0;
      for(let level=0;level<256;level++){cumulative+=histogram[level];if(cumulative>=count*fraction)return level;}
      return 255;
    };
    const peak=percentile(.99),reference=Math.max(1,Math.min(percentile(.65),peak-12));
    const toLinear=value=>{value/=255;return value<=.04045?value/12.92:Math.pow((value+.055)/1.055,2.4)};
    const toDisplay=value=>Math.round(255*(value<=.0031308?12.92*value:1.055*Math.pow(value,1/2.4)-.055));
    const whitePeak=percentile(.995),whiteStart=Math.max(reference,whitePeak-8);
    if(whiteMask&&!lighting.mask){
      lighting.mask=new Float32Array(256);
      for(let level=0;level<256;level++){
        const position=peak-percentile(.1)>=16?Math.max(0,Math.min(1,(level-whiteStart)/Math.max(1,whitePeak-whiteStart))):0;
        lighting.mask[level]=position*position*(3-2*position);
      }
    }
    const base=rgb.map(toLinear),tones=new Uint8ClampedArray(768);
    for(let level=0;level<256;level++){
      const shade=Math.pow(Math.min(1,level/reference),1.4);
      const position=Math.max(0,Math.min(1,(level-reference)/Math.max(12,peak-reference)));
      const glint=position*position*(3-2*position)*.10+Math.pow(position,8)*.08;
      const maskPosition=peak-percentile(.1)>=16?Math.max(0,Math.min(1,(level-whiteStart)/Math.max(1,whitePeak-whiteStart))):0;
      const mask=whiteMask?lighting.mask[level]:0;
      const highlight=glint+(1-glint)*mask;
      for(let channel=0;channel<3;channel++)tones[level*3+channel]=toDisplay(Math.min(1,base[channel]*shade*(1-highlight)+highlight));
    }
    for(let index=0;index<data.length;index+=4){
      if(!data[index+3])continue;
      const level=Math.round(.2126*data[index]+.7152*data[index+1]+.0722*data[index+2])*3;
      data[index]=tones[level];data[index+1]=tones[level+1];data[index+2]=tones[level+2];
    }
    return data;
  }
  const cache=new Map,sourceCache=new Map;
  let database;
  function openCache(){
    if(database)return database;
    database=new Promise(resolve=>{
      try{
        if(!window.indexedDB){resolve(null);return;}
        const request=indexedDB.open('mk-backer-previews-v1',1);
        request.onupgradeneeded=()=>{request.result.createObjectStore('images');request.result.createObjectStore('metadata',{keyPath:'key'});};
        request.onsuccess=()=>resolve(request.result);
        request.onerror=request.onblocked=()=>resolve(null);
        setTimeout(()=>resolve(null),700);
      }catch{resolve(null);}
    });return database;
  }
  async function readPreview(key){
    const db=await openCache();if(!db)return null;
    return new Promise(resolve=>{try{const request=db.transaction('images').objectStore('images').get(key);request.onsuccess=()=>resolve(request.result||null);request.onerror=()=>resolve(null);setTimeout(()=>resolve(null),400);}catch{resolve(null);}});
  }
  async function savePreview(key,url){
    const db=await openCache();if(!db||url.length*2>24*1024*1024)return;
    try{
      const transaction=db.transaction(['images','metadata'],'readwrite'),images=transaction.objectStore('images'),metadata=transaction.objectStore('metadata');
      transaction.onerror=()=>{};
      images.put(url,key);metadata.put({key,size:url.length*2,time:Date.now()});
      const request=metadata.getAll();request.onsuccess=()=>{
        const rows=request.result.sort((a,b)=>a.time-b.time);let total=rows.reduce((sum,row)=>sum+row.size,0),count=rows.length;
        for(const row of rows){if(total<=24*1024*1024&&count<=48)break;images.delete(row.key);metadata.delete(row.key);total-=row.size;count--;}
      };
    }catch{}
  }
  function prepareSource(source,maxSize){
    const key=source+'|'+maxSize;if(sourceCache.has(key))return sourceCache.get(key);
    const result=new Promise((resolve,reject)=>{
      const image=new Image;image.crossOrigin='anonymous';image.decoding='async';image.onload=()=>{
        let canvas;
        try{
          const scale=Math.min(1,maxSize/Math.max(image.naturalWidth,image.naturalHeight));canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(image.naturalWidth*scale));canvas.height=Math.max(1,Math.round(image.naturalHeight*scale));
          const context=canvas.getContext('2d',{willReadFrequently:true});context.drawImage(image,0,0,canvas.width,canvas.height);
          resolve({lighting:{},width:canvas.width,height:canvas.height,data:context.getImageData(0,0,canvas.width,canvas.height).data});
        }catch(error){reject(error);}finally{if(canvas)canvas.width=canvas.height=1;}
      };image.onerror=()=>reject(new Error('Unable to load the backer cutout.'));image.src=source;
    });sourceCache.set(key,result);while(sourceCache.size>2)sourceCache.delete(sourceCache.keys().next().value);result.catch(()=>sourceCache.delete(key));return result;
  }
  function colorize(source,name,maxSize=1600,whiteMask=false){
    const hex=color(name);if(!source||!hex)return Promise.resolve(source);
    const key='lighting-mask-v1|'+source+'|'+hex+'|'+maxSize+'|'+whiteMask;
    if(cache.has(key))return cache.get(key);
    const result=(async()=>{
      if(whiteMask){const saved=await readPreview(key);if(saved)return saved;}
      const prepared=await prepareSource(source,maxSize);let canvas;
      try{
        canvas=document.createElement('canvas');canvas.width=prepared.width;canvas.height=prepared.height;
        const context=canvas.getContext('2d'),pixels=context.createImageData(prepared.width,prepared.height);pixels.data.set(prepared.data);
        tintPixels(pixels.data,hex,whiteMask,prepared.lighting);context.putImageData(pixels,0,0);const url=canvas.toDataURL('image/png');if(whiteMask)void savePreview(key,url);return url;
      }finally{if(canvas)canvas.width=canvas.height=1;}
    })();cache.set(key,result);while(cache.size>8)cache.delete(cache.keys().next().value);result.catch(()=>cache.delete(key));return result;
  }
  const cartFiles=new Map();
  function prepareCartPreview(variant){
    if(!variant?.source||!color(variant.color))return;
    const key=String(variant.id)+'|'+variant.source+'|'+variant.color;
    if(cartFiles.has(key))return;
    const entry={};cartFiles.set(key,entry);
    while(cartFiles.size>12)cartFiles.delete(cartFiles.keys().next().value);
    colorize(variant.source,variant.color,400,true).then(url=>new Promise((resolve,reject)=>{
      const image=new Image();image.onload=()=>{
        const canvas=document.createElement('canvas');canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;
        canvas.getContext('2d').drawImage(image,0,0);
        canvas.toBlob(blob=>{canvas.width=canvas.height=1;resolve(blob)},'image/webp',.82);
      };image.onerror=reject;image.src=url;
    })).then(blob=>{if(blob&&blob.size<=120000)entry.file=new File([blob],'backer-'+variant.id+(blob.type==='image/webp'?'.webp':'.png'),{type:blob.type});}).catch(()=>cartFiles.delete(key));
  }
  if(!customElements.get('mk-backer-cart-preview'))customElements.define('mk-backer-cart-preview',class extends HTMLElement{
    connectedCallback(){
      const image=this.querySelector('img');if(!image||!this.dataset.source||!color(this.dataset.color))return;
      const source=this.dataset.source,name=this.dataset.color;
      colorize(source,name,400,true).then(url=>{if(this.isConnected&&this.dataset.source===source&&this.dataset.color===name){image.removeAttribute('srcset');image.src=url;}}).catch(()=>{});
    }
  });
  function swatches(root=document){
    root.querySelectorAll('[data-mk-backer-swatch]').forEach(label=>{
      const hex=color(label.dataset.mkBackerSwatch);
      if(hex) label.style.setProperty('--mk-backer-color',hex);
    });
  }
  window.MKBackerColors={color,colorize,tintPixels,swatches};
  const style=document.createElement('style');
  style.textContent=`
  .mk-backer-toggle{display:flex;align-items:center;justify-content:space-between;width:100%;min-height:47px;padding:0 20px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));border:1px solid rgba(var(--color-foreground),.4);border-radius:var(--inputs-radius,8px);font:inherit;font-size:13px;letter-spacing:.1rem;cursor:pointer}
  .mk-backer-toggle [data-mk-backer-swatch]{padding:0!important;gap:10px!important}.mk-backer-toggle .mk-backer-chip{width:18px;height:18px}
  .mk-backer-tray-panel{position:fixed;inset:auto;margin:0;padding:14px;box-sizing:border-box;overflow:auto;overscroll-behavior:contain;background:rgb(var(--color-background));color:rgb(var(--color-foreground));border:1px solid rgba(var(--color-foreground),.3);border-radius:14px;box-shadow:0 8px 30px #0003}
  .mk-backer-tray-panel fieldset{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;border:0;padding:0;margin:0;min-width:0}
  .mk-backer-tray-panel label[data-mk-backer-swatch]{margin:0!important;width:100%;min-width:0;max-width:100%;min-height:44px;box-sizing:border-box;justify-content:flex-start;text-align:left;padding:9px 10px!important;gap:8px!important;font-size:13px;line-height:1.3;letter-spacing:.02em;overflow-wrap:anywhere;border-radius:10px}.mk-backer-tray-panel .mk-backer-chip{width:18px;height:18px}
  [data-mk-backer-swatch]{display:inline-flex!important;align-items:center;gap:8px!important;padding:9px 12px!important}
  .mk-backer-chip{display:inline-block;width:22px;height:22px;flex:none;border-radius:50%;background:var(--mk-backer-color,#eee);border:1px solid #999}
  mk-backer-preview{display:block}mk-backer-preview figure{margin:0 0 16px;padding:12px;border:1px solid rgba(var(--color-foreground),.15);border-radius:12px;text-align:center}
  mk-backer-preview img{display:block;margin:auto;width:100%;height:auto;max-height:440px;object-fit:contain}
  mk-backer-preview figcaption{font:inherit;font-size:13px;margin-top:8px}
  mk-backer-preview [hidden]{display:none!important}
  `;
  document.head.appendChild(style);
  if(!customElements.get('mk-backer-preview'))customElements.define('mk-backer-preview',class extends HTMLElement{
    connectedCallback(){
      if(this.started)return;this.started=true;this.config=JSON.parse(this.querySelector('[data-backer-config]').textContent);
      const form=this.closest('product-info')?.querySelector('product-form form');
      this.cartForm=form;
      this.onCartData=event=>{
        const id=event.formData.get('id'),variant=this.config.variants.find(item=>String(item.id)===String(id));
        if(!variant?.source)return;
        const key=String(variant.id)+'|'+variant.source+'|'+variant.color,file=cartFiles.get(key)?.file;
        if(file)event.formData.set('properties[_Backer Preview]',file);
      };
      form?.addEventListener('formdata',this.onCartData);
      this.pick(this.config.selected);
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
        if(String(event.data.sectionId)!==this.dataset.section)return;
        this.pick(event.data.variant?.id);swatches(this.closest('product-info')||document);
      });
      swatches(this.closest('product-info')||document);
    }
    disconnectedCallback(){this.unsubscribe?.();this.cartForm?.removeEventListener('formdata',this.onCartData);this.started=false}
    async pick(id){
      const version=this.version=(this.version||0)+1,variant=this.config.variants.find(item=>String(item.id)===String(id));
      if(!variant?.source)return;
      prepareCartPreview(variant);
      try {
        const url=await colorize(variant.source,variant.color,1600,true);
        if(this.version!==version||!this.isConnected)return;
        const root=this.closest('product-info');
        root?.querySelector('media-gallery')?.setActiveMedia(this.dataset.section+'-'+variant.media,true);
        root?.querySelectorAll('[data-media-id]').forEach(media=>{
          if(String(media.dataset.mediaId)!==this.dataset.section+'-'+variant.media)return;
          media.querySelectorAll('img').forEach(image=>{image.srcset='';image.src=url;});
        });
      } catch {}
    }
  });
  if(!customElements.get('mk-backer-tray'))customElements.define('mk-backer-tray',class extends HTMLElement{
    connectedCallback(){
      this.button=this.querySelector('[data-backer-toggle]');this.panel=this.querySelector('[popover]');
      this.button.onclick=()=>this.panel.matches(':popover-open')?this.panel.hidePopover():this.panel.showPopover();
      this.position=()=>{
        if(!this.panel.matches(':popover-open'))return;
        const view=window.visualViewport, width=view?.width||innerWidth,height=view?.height||innerHeight,left=view?.offsetLeft||0,top=view?.offsetTop||0;
        const bounds=this.button.getBoundingClientRect(),w=Math.min(440,width-24),h=Math.max(80,Math.min(400,height-24));
        Object.assign(this.panel.style,{width:w+'px',maxHeight:h+'px',left:Math.max(left+12,Math.min(bounds.left,left+width-w-12))+'px',top:Math.max(top+12,Math.min(bounds.bottom+8,top+height-h-12))+'px'});
      };
      this.panel.addEventListener('toggle',()=>{const open=this.panel.matches(':popover-open');this.button.setAttribute('aria-expanded',String(open));if(open){this.position();this.panel.querySelector('input:checked')?.focus();}});
      this.addEventListener('change',event=>{if(event.target.matches('input[type=radio]')){this.panel.hidePopover();this.button.focus();}});
      window.addEventListener('resize',this.position);window.addEventListener('scroll',this.position,true);window.visualViewport?.addEventListener('resize',this.position);
    }
    disconnectedCallback(){window.removeEventListener('resize',this.position);window.removeEventListener('scroll',this.position,true);window.visualViewport?.removeEventListener('resize',this.position);}
  });
  swatches();
})();


